import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    title: string;
    type: number;
}

export interface CreateDate {
    value: string;
    viewValue: string;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'filter-content-dialog',
    templateUrl: 'filter-content-dialog.html',
    styleUrls: ['filter-content-dialog.scss']
})
// tslint:disable-next-line:component-class-suffix
export class FilterContentDialog {
    result: DialogData;
    sortBy = 2;
    selectedDate = '1';

    orderBy: any;
    selectedStatus: any = [];
    statusData: any;
    tradeData: any;
    selectedUploadDate: any = Date;
    defectData: any = [];
    tradeID: any = [];
    defectID: any = [];

    selectedApprovalStatus: any;
    approvalStatus = [
        { id: 1, name: 'Pending' },
        { id: 2, name: 'Approve' },
        { id: 3, name: 'Reject' }
    ];

    date: CreateDate[] = [
        { value: '1', viewValue: 'All Time' },
        { value: '2', viewValue: 'Today' },
        { value: '3', viewValue: 'Yesterday' },
        { value: '4', viewValue: 'This Week' },
        { value: '5', viewValue: 'This Month' }
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: DialogData
    ) {
        if (this._data != null) {
            this.result = this._data;
        }
    }
}
